import { render, staticRenderFns } from "./Handover.vue?vue&type=template&id=f60d0666&"
import script from "./Handover.vue?vue&type=script&lang=js&"
export * from "./Handover.vue?vue&type=script&lang=js&"
import style0 from "./Handover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports